import React, { useEffect } from "react";
import { LanguageConstants } from "../constants/LanguageConstants";
import useMakeRequest from "../utils/ApiHelper";
import { ApiConstants } from "../constants/ApiConstants";
import FrontLoader from "../component/layout/FrontLoader";

function OrderSurveyMessage(props: any) {
  const surveyStatus = useMakeRequest();
  const handeCancelSurvey = () => {
    const payload = {
      order_id: props?.data?.uuid,
    };
    surveyStatus.makeRequest({
      payload,
      url: ApiConstants?.QuotesStatusDetail,
      toastStatus: false,
    });
  };

  useEffect(() => {
    if (surveyStatus.status) {
      props?.setSurveymessageShow(false);
    props?.setApiRefresh(true)
    }
  }, [surveyStatus.status]);

  const handelShowQuestion = ()=>{
      props?.setSurveymessageShow(false)
      props?.setSurveyShow(true)

  }

  return (
    <>
      {surveyStatus.loading ? <FrontLoader /> : null}
      <div
        className="modal fade com-modal short-modal show"
        id="surveymessage"
        aria-labelledby="editMessageProductModalLabel"
        aria-hidden="false"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* <div className="modal-header">
                                <h5 className="modal-title" id="editMessageProductModalLabel">{LanguageConstants?.Edit_Quantity}</h5>
                            </div> */}
            <div className="modal-body pb-0 text-center">
              <p className="modal-para mt-2">
                {LanguageConstants?.SURVEY_MESSAGE}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row w-100">
                <div className="col-6 ps-0">
                  <button
                    type="submit"
                    className="round-btn round-btn-gray m-0 w-100"
                    onClick={() => handeCancelSurvey()}
                  >
                    {LanguageConstants?.NO}
                  </button>
                </div>
                <div className="col-6 pe-0">
                  <button
                    type="submit"
                    className="round-btn m-0 w-100"
                    onClick={() => handelShowQuestion()}
                  >
                    {LanguageConstants?.YES}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderSurveyMessage;
